import { Dayjs } from 'dayjs';

export type DateRange = [Dayjs | null, Dayjs | null];

export const getRestartingRangeChange = (
  [prevStart, prevEnd]: DateRange,
  [newStart, newEnd]: DateRange,
): DateRange => {
  const hadCompleteRange = !!(prevStart && prevEnd);
  const isStillComplete = !!(newStart && newEnd);
  if (!hadCompleteRange || !isStillComplete) {
    return [newStart, newEnd];
  }

  const startChanged = !newStart.isSame(prevStart, 'day');
  const endChanged = !newEnd.isSame(prevEnd, 'day');
  return [startChanged || !endChanged ? newStart : newEnd, null];
};
